module.exports = __webpack_public_path__ + "media/icons/download-a771aab6.svg";